import { ContentType } from "@redotech/redo-support-common/conversation";
import * as z from "zod";
import { literal, object, string } from "zod";
import {
  AutoGeneratedFieldsSchema,
  BaseActionableComponentMessageSchema,
} from "../message-parser-utils";

export const FaqLinkDataSchema = object({
  faqId: string().describe("The ID of the FAQ article"),
  faqTitle: string().describe("The title of the FAQ article"),
  optionalCustomFaqUrl: string()
    .optional()
    .describe("Optional custom URL for the FAQ"),
});

export const FaqLinkMessageSchema = BaseActionableComponentMessageSchema.extend(
  {
    contentType: literal(ContentType.FAQ_LINK),
    structuredContent: FaqLinkDataSchema,
  },
);

export const FaqLinkMessageDbParser = FaqLinkMessageSchema.merge(
  AutoGeneratedFieldsSchema,
);

export type FaqLinkMessage = z.infer<typeof FaqLinkMessageDbParser>;
export type FaqLinkData = z.infer<typeof FaqLinkDataSchema>;
